import React from 'react';
import { whyElite } from '../mockData';
import { CheckCircle } from 'lucide-react';

const WhyElite = () => {
  return (
    <section id="why-elite" className="section-dark">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-2">POR QUÉ ELITE INTERNACIONAL</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle body-medium">
            Somos la elección de futbolistas y clubes que buscan excelencia, profesionalidad y resultados contrastados.
          </p>
        </div>

        <div className="why-elite-grid">
          {whyElite.map(item => (
            <div key={item.id} className="why-elite-card">
              <CheckCircle size={40} className="check-icon" />
              <h3 className="heading-5">{item.title}</h3>
              <p className="body-small">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyElite;